module.exports = __webpack_public_path__ + "static/media/work1.3.ba3e3a43.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/home/work1.3.png
// module id = 518
// module chunks = 4